<div class="close-container">
  <img src="../assets/close_icon.svg" (click)="onClickClose()" class="close" role="button" tabindex="0" aria-label="Close" alt="Close" (keydown.enter)="onClickClose()" (keydown.space)="$event.preventDefault(); onClickClose()" />
</div>
<p class="title-section text-heading-color text-center-align font-weight-600 font-18">myQ Connected Garage - Introduction Video </p>

<!-- <div>
  <p id="p2" class="font-16 font-weight-500 black-color">Tutorial</p>
  <p id="p2" class="font-12 font-weight-400 black-color">
    Learn how to use your vehicle's telematic features on the HondaLink app
  </p>
</div> -->

<div *ngIf="!isAcura">
  <!-- <p id="p2" class="font-16 font-weight-500 black-color">Tutorial</p> -->
  <!-- <p id="p2" class="font-12 font-weight-400 black-color">
    Learn how to use your vehicle's telematic features on the HondaLink app
  </p> -->
  <div class="video-container">
    <!-- <video controls (click)="toggleVideo()" #videoPlayer>
    <source
      src="https://www.learningcontainer.com/wp-content/uploads/2020/05/sample-mp4-file.mp4"
      type="video/mp4"
    />
  </video> -->
    <iframe class="demo-video" src="https://youtube.com/embed/Z3V4sC1GN7w" frameborder="0" height="100%" width="100%"
      allowfullscreen></iframe>
  </div>
</div>
<div *ngIf="isAcura">
  <!-- <p id="p2" class="font-16 font-weight-500 black-color">Tutorial</p> -->
  <!-- <p id="p2" class="font-12 font-weight-400 black-color">
    Learn how to use your vehicle's telematic features on the AcuraLink app
  </p> -->
  <div class="video-container">
    <iframe class="demo-video" src="https://youtube.com/embed/VCf9AVqudhQ" frameborder="0" height="100%" width="100%"
      allowfullscreen></iframe>
  </div>
</div>
<div class="container-desc">
  <!-- <p id="p1" class="font-15 font-weight-500 black-color">
    Vehicle Heath Report
  </p> -->
  <!-- <p id="p2" class="font-12 font-weight-400 black-color">
    Stay ahead of the curve with monthly reports of your vehicle status
    delivered to your inbox.
  </p> -->
</div>

<div class="btn-container">
  <button mat-flat-button class="edit-form-button mutual-btn button-right-no-radius" (click)="onClickClose()">
    Close
  </button>
</div>
